<template>
  <FilterableDropdown
    :modelValue="modelValue"
    :textLabel="textLabel"
    :placeholder="placeholder"
    :options="returnLocationOptions"
    :customLabel="getLocationDisplayName"
    :size="size"
    @update:modelValue="updateReturnLocation"
    @search-change="searchCustomers"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import FilterableDropdown from '@/components/core/FilterableDropdown.vue';
import ReceivingCustomersQuery from '@/gql/customers/ReceivingCustomers.gql';
import TerminalsQuery from '@/gql/terminals/Terminals.gql';
import { getLocationDisplayName } from '@/utils/container';
import type { ContainerReturnLocation } from '@/utils/container';

// Picks where a container is returned to: any customer (searched on the server) or terminal,
// like a trip's destination in ContainerTripsTable.
export default defineComponent({
  name: 'ContainerReturnLocationDropdown',
  components: {
    FilterableDropdown,
  },
  props: {
    modelValue: {
      type: Object as PropType<ContainerReturnLocation | null>,
      default: null,
    },
    textLabel: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: 'select return location...',
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  emits: ['update:modelValue'],
  data(): any {
    return {
      customerNameQuery: '',
      customers: [],
      terminals: [],
    };
  },
  computed: {
    returnLocationOptions(): ContainerReturnLocation[] {
      const vm = this as any;
      const options = ((vm.terminals || []) as ContainerReturnLocation[]).concat(vm.customers || []);
      // Keep the saved location selectable when the current customer search doesn't return it.
      if (vm.modelValue && !options.find((option) => String(option.id) === String(vm.modelValue.id))) {
        options.push(vm.modelValue);
      }
      return options;
    },
  },
  methods: {
    getLocationDisplayName,
    updateReturnLocation(returnLocation: ContainerReturnLocation | null) {
      (this as any).$emit('update:modelValue', returnLocation ?? null);
    },
    searchCustomers(customerName: string) {
      (this as any).customerNameQuery = customerName;
    },
  },
  apollo: {
    customers: {
      query: ReceivingCustomersQuery,
      debounce: 100,
      variables() {
        return {
          name: (this as any).customerNameQuery,
        };
      },
      update: (data) => data.receivingCustomers,
    },
    terminals: {
      query: TerminalsQuery,
    },
  },
});
</script>
